module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./CertificatesView.js"));
	}, "ProtectionView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ProtectionView!./src/pages/Shop/Member/Personal/Certificates/CertificatesView.js
// module id = 983
// module chunks = 438